// extracted by mini-css-extract-plugin
export var boxItems = "_8e-1";
export var boxItemsLg = "_8e-2";
export var button = "_8e-7";
export var buttonHoverless = "_8e-9";
export var buttonLg = "_8e-8";
export var filterGroupBox = "_8e-0";
export var icon = "_8e-3";
export var iconSecondary = "_8e-6";
export var iconWrapper = "_8e-4";
export var iconWrapperLg = "_8e-5";
export var truncatedLabel = "_8e-a";